module.exports = __webpack_public_path__ + "static/img/4.06e7a3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/4.png
// module id = kE0m
// module chunks = 0